export default {
  SET_SITE_OWNERSHIPS: function (state, payload) {
    state.siteOwnerships = payload;
  }
}
